//数据持久化插件
// import createPersistedState from 'vuex-persistedstate'

export default {
    state: {
        // 个人微信的登录者,以前是单用户登录，现在改为多用户登录
        wxbPerson: [],
        // 个人微信Id
        wxbId: '',
        // 在未登录的时候去查询“分配给我的”放到“我的”里面。 如果是已经登录则继续查询“分配给我的”和“我的”放在我的里面
        // 个人微信的会话列表    “我的”会话列表
        wxbMySessionList: [],
        // 个人微信的分配的会话列表 “我分配的”会话列表
        wxbShareSessionList: [],
        // 分配给我的会话列表
        wxbFollowSessionList: [],
        // 个人微信的聊天记录, 每次发送消息或者接收消息都往这个数组加
        wxbMessageList: [],
        // 个人微信的好友列表
        wxbFriendsList: [],
        // 个人微信的群聊列表
        wxbGroupChatList: [],
        // 微信在线聊天初始化false表示不请求会话列表，true表示请求会话列表
        wxbOnlineInitData: true,
        // 我的总页数
        wxbMySessionPages: 0,
        // 别人分配给我的总页数
        wxbFollowSessionPages: 0,
        // 我分给别人的总页数
        wxbShareSessionPages: 0,
        // 我的页码,当前页
        wxbMySessionCurrentPage: 1,
        // 别人分配给我的页码,当前页
        wxbFollowSessionCurrentPage: 1,
        // 我分给别人的页码,当前页
        wxbShareSessionCurrentPage: 1,
        // 会话列表分页查询，每页条数
        wxbPageCount: 200,
        // 在线聊天当前选中的用户对象
        wxbCurUser: null,
        // 在线聊天的消息是否为正在加载的历史消息,是否加载的历史消息，如果是true则滚动条无需滚动到底部，false滚动条滚动到底部
        wxbLoadHisMsg: false,
    },
    mutations: {
        setWxbId (state, wxbId) {
            state.wxbId = wxbId
        },
        setWxbPerson (state, wxbPerson) {
            state.wxbPerson = wxbPerson
        },
        // 我的 会话
        setWxbMySessionList (state, wxbMySessionList) {
            state.wxbMySessionList = JSON.parse(JSON.stringify(wxbMySessionList))
        },
        // 我分配给别人的会话
        setWxbShareSessionList (state, wxbShareSessionList) {
            state.wxbShareSessionList = JSON.parse(JSON.stringify(wxbShareSessionList))
        },
        // 别人分配给我的会话
        setWxbFollowSessionList (state, wxbFollowSessionList) {
            state.wxbFollowSessionList = JSON.parse(JSON.stringify(wxbFollowSessionList))
        },
        // 消息加1
        setWxbMessageList (state, wxbMessageList) {
            let data = JSON.parse(JSON.stringify(wxbMessageList))
             state.wxbMessageList.push(data)
        },
        setWxbMessageListUnshift (state, wxbMessageList) {
            let data = JSON.parse(JSON.stringify(wxbMessageList))
            state.wxbMessageList.unshift(data)
        },
        setWxbFriendsList (state, wxbFriendsList) {
            state.wxbFriendsList = JSON.parse(JSON.stringify(wxbFriendsList))
        },
        setWxbGroupChatList (state, wxbGroupChatList) {
            state.wxbGroupChatList = JSON.parse(JSON.stringify(WxbGroupChatList))
        },
        setWxbOnlineInitData (state, wxbOnlineInitData) {
            state.wxbOnlineInitData = wxbOnlineInitData
        },
        // 我的会话总页数
        setWxbMySessionPages (state, wxbMySessionPages) {
            state.wxbMySessionPages = wxbMySessionPages
        },
        // 别人分给我的会话总页数
        setWxbFollowSessionPages (state, WxbFollowSessionPages) {
            state.WxbFollowSessionPages = WxbFollowSessionPages
        },
        // 我分给别人的会话总页数
        setWxbShareSessionPages (state, WxbShareSessionPages) {
            state.WxbShareSessionPages = WxbShareSessionPages
        },
        // 我的会话 当前页码
        setWxbMySessionCurrentPage (state, wxbMySessionCurrentPage) {
            state.wxbMySessionCurrentPage = wxbMySessionCurrentPage
        },
        // 别人分给我的会话 当前页码
        setWxbFollowSessionCurrentPage (state, wxbFollowSessionCurrentPage) {
            state.wxbFollowSessionCurrentPage = wxbFollowSessionCurrentPage
        },
        // 我分给别人的会话 当前页码
        setWxbShareSessionCurrentPage (state, wxbShareSessionCurrentPage) {
            state.wxbShareSessionCurrentPage = wxbShareSessionCurrentPage
        },
        // 在线聊天记录当前选中对象
        setWxbCurUser (state, wxbCurUser) {
            state.wxbCurUser = wxbCurUser
        },
        // 在线聊天的消息是否为正在加载的历史消息
        setWxbLoadHisMsg (state, wxbLoadHisMsg) {
            state.wxbLoadHisMsg = wxbLoadHisMsg
        },
        // 清空在线聊天缓存
        setWxbClearOnlineCache (state) {
            console.log('清空企微宝在线聊天的缓存setWxbClearOnlineCache')
            state.wxbOnlineInitData = true
            state.wxbPerson = []
            state.wxbMySessionList = []
            state.wxbShareSessionList = []
            state.wxbFollowSessionList = []
            state.wxbFriendsList = []
            state.wxbGroupChatList = []
            state.wxbMySessionCurrentPage = 1
            state.wxbFollowSessionCurrentPage = 1
            state.wxbShareSessionCurrentPage = 1
            state.wxbCurUser = null
        }
    },
    actions: {
        setWxbId (context, wxbId) {
            context.commit('setWxbId', wxbId)
        },
        setWxbPerson (context, wxbPerson) {
            context.commit('setWxbPerson', wxbPerson)
        },
        // 我的会话列表
        setWxbMySessionList (context, wxbMySessionList) {
            context.commit('setWxbMySessionList', wxbMySessionList)
        },
        // 我分配的会话列表
        setWxbShareSessionList (context, wxbShareSessionList) {
            context.commit('setWxbShareSessionList', wxbShareSessionList)
        },
        // 别人分给我的会话列表
        setWxbFollowSessionList (context, wxbFollowSessionList) {
            context.commit('setWxbFollowSessionList', wxbFollowSessionList)
        },
        // 消息加1
        setWxbMessageList (context, messageList) {
            context.commit('setWxbMessageList', messageList)
        },
        setWxbMessageListUnshift (context, messageList) {
            context.commit('setWxbMessageListUnshift', messageList)
        },
        setWxbFriendsList (context, wxbFriendsList) {
            context.commit('setWxbFriendsList', wxbFriendsList)
        },
        setWxbGroupChatList (context, wxbGroupChatList) {
            context.commit('setWxbGroupChatList', wxbGroupChatList)
        },
        setWxbOnlineInitData (context, wxbOnlineInitData) {
            context.commit('setWxbOnlineInitData', wxbOnlineInitData)
        },
        // 我的会话总页数
        setWxbMySessionPages (context, wxbMySessionPages) {
            context.commit('setWxbMySessionPages', wxbMySessionPages)
        },
        // 别人分给我的会话总页数
        setWxbFollowSessionPages (context, wxbFollowSessionPages) {
            context.commit('setWxbFollowSessionPages', wxbFollowSessionPages)
        },
        // 我分给别人的会话总页数
        setWxbShareSessionPages (context, wxbShareSessionPages) {
            context.commit('setWxbShareSessionPages', wxbShareSessionPages)
        },
        // 在线聊天记录当前选中对象
        setWxbCurUser (context, curUser) {
            context.commit('setWxbCurUser', curUser)
        },
        // 在线聊天的消息是否为正在加载的历史消息
        setWxbLoadHisMsg (context, wxbLoadHisMsg) {
            context.commit('setWxbLoadHisMsg', wxbLoadHisMsg)
        },
        // 清空在线聊天缓存
        setWxbClearOnlineCache(context) {
            context.commit('setWxbClearOnlineCache')
        }
    },
    getters: {
        // 我的会话数据 优化，需要根据查询条件进行过滤
       /* myAllTalkList: (state) =>
            (key) => {
                if (state.mySessionList.length !== 0 && key !== '') {
                    return state.mySessionList.concat(state.followSessionList).filter((item) => {
                        return item.name.indexOf(key) !== -1
                    })
                } else if (state.mySessionList.length !== 0 && key === '') {
                    return state.mySessionList.concat(state.followSessionList)
                } else if (state.mySessionList.length === 0 && key !== '') {
                    return state.followSessionList.filter((item) => {
                        return item.name.indexOf(key) !== -1
                    })
                } else {
                    return state.followSessionList
                }
            }*/
    },
    // plugins: [createPersistedState({ storage: window.sessionStorage })]
}
